import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, CardBody, Card, Container, Form, Input, FormFeedback, Spinner } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik & Yup
import * as Yup from "yup";
import { useFormik } from "formik";

// Helpers & APIs
import { formatDataBeforeSend } from "helpers/GeneralHelper";
import { forgotPassword } from "model/LoginModel";
import { toast } from "react-toastify";

// Images
import loginLogo from "../../assets/images/login-logo.png";

const ForgetPassword = () => {
  document.title = "Forgot Password | Funnl";
  const formatOptions = [];
  const [fields, setFields] = useState();
  const currentDate = new Date();
  const navigate = useNavigate();
    const [showSpinner, setShowSpinner] = useState(false);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  

  // Formik setup
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      setShowSpinner(true)
      const inputFields = {};
      setFields(inputFields);

      const formData = formatDataBeforeSend(inputFields, formatOptions);
      formData.append("Username", values.email);

      try {
        const response = await forgotPassword(formData);
        if (response?.IsSuccess) {
          setShowSpinner(false)
          toast.success(response?.Message || "Password reset email sent successfully!");
          navigate(`/login`);
        } else {
          setShowSpinner(false)
          toast.error(response?.Message || "Something went wrong. Please try again.");
        }
      } catch (err) {
        setShowSpinner(false)
        toast.error(err?.message || "An error occurred. Please try again.");
      }
    },
  });

  return (
    <div className="login-wrapper">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={5} xl={4}>
            <div className="text-center mb-4">
              <img src={loginLogo} alt="logo" className="login-img-pos" />
            </div>

            <Card className={`p-2 border-0 shadow-sm ${isMobile ? 'card-wdth-mobile' : 'card-wdth'}`}>
              <CardBody>
                <h4 className="text-center mb-4 fw-bold">Forgot Password</h4>

                <Form onSubmit={validation.handleSubmit}>
                  <div className="mb-3">
                    <Input
                      name="email"
                      placeholder="Email"
                      type="email"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email}
                      invalid={!!(validation.touched.email && validation.errors.email)}
                    />
                    {validation.touched.email && validation.errors.email && (
                      <FormFeedback>{validation.errors.email}</FormFeedback>
                    )}
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-gradient" disabled={showSpinner}>
                    {showSpinner && <Spinner size="sm" />}  Continue <span className="ms-1">→</span>
                    </button>
                  </div>

                  <div className="text-center mt-3">
                    Wait, I remember my password...{" "}
                    <Link to="/login" className="text-orange fw-medium">
                      Click Here
                    </Link>
                  </div>
                </Form>
              </CardBody>
            </Card>

            <div className="text-center mt-4 text-muted small">
              ©{currentDate?.getFullYear()} Powered by Funnl
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(ForgetPassword);

ForgetPassword.propTypes = {
  history: PropTypes.object,
};
